// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".current-ip[data-v-3d3d1f5f] {\n  background: #FEFCD8;\n}\n.not-recommended[data-v-3d3d1f5f] {\n  color: #eb5757;\n}", ""]);
// Exports
module.exports = exports;
